import { render, staticRenderFns } from "./affairs.vue?vue&type=template&id=c0b83c0a&scoped=true&"
import script from "./affairs.vue?vue&type=script&lang=js&"
export * from "./affairs.vue?vue&type=script&lang=js&"
import style0 from "./affairs.vue?vue&type=style&index=0&id=c0b83c0a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0b83c0a",
  null
  
)

export default component.exports